import FJClothesChangerLeftContainer from './FJClothesChangerLeft/FJClothesChangerLeftContainer';
import FJClothesChangerRightContainer from './FJClothesChangerRight/FJClothesChangerRightContainer';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FJActionClothesChanger from '../../redux/action/FJActionClothesChanger.js';

const FJClothesChanger = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionClothesChanger.initClothesImageAction());
    }, []);

    return (
        <>
            <FJClothesChangerLeftContainer />
            <FJClothesChangerRightContainer />
        </>
    );
};

export default FJClothesChanger;
